"use client";

import { useState, useEffect } from "react";

interface CountdownProps {
	targetDate: Date;
	className?: string;
}

export function Countdown({ targetDate, className = "" }: CountdownProps) {
	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	});

	useEffect(() => {
		const calculateTimeLeft = () => {
			const now = new Date().getTime();
			const target = targetDate.getTime();
			const difference = target - now;

			if (difference > 0) {
				setTimeLeft({
					days: Math.floor(difference / (1000 * 60 * 60 * 24)),
					hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
					minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
					seconds: Math.floor((difference % (1000 * 60)) / 1000)
				});
			} else {
				setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
			}
		};

		calculateTimeLeft();
		const interval = setInterval(calculateTimeLeft, 1000);

		return () => clearInterval(interval);
	}, [targetDate]);

	const formatNumber = (num: number) => String(num).padStart(2, "0");

	return (
		<div className={`flex items-center gap-1 ${className}`}>
			{timeLeft.days > 0 && (
				<>
					<div className="flex items-baseline justify-center gap-0.5 bg-[#BF540D] px-1.5 py-0.5 rounded w-12">
						<span className="text-white text-xs font-semibold">{formatNumber(timeLeft.days)}</span>
						<span className="text-white text-[10px] font-medium">d</span>
					</div>
					<span className="text-[#3D1C06] text-xs">•</span>
				</>
			)}
			<div className="flex items-baseline justify-center gap-0.5 bg-[#BF540D] px-1.5 py-0.5 rounded w-10">
				<span className="text-white text-xs font-semibold">{formatNumber(timeLeft.hours)}</span>
				<span className="text-white text-[10px] font-medium">h</span>
			</div>
			<span className="text-[#3D1C06] text-xs">•</span>
			<div className="flex items-baseline justify-center gap-0.5 bg-[#BF540D] px-1.5 py-0.5 rounded w-10">
				<span className="text-white text-xs font-semibold">{formatNumber(timeLeft.minutes)}</span>
				<span className="text-white text-[10px] font-medium">m</span>
			</div>
			<span className="text-[#3D1C06] text-xs">•</span>
			<div className="flex items-baseline justify-center gap-0.5 bg-[#BF540D] px-1.5 py-0.5 rounded w-10">
				<span className="text-white text-xs font-semibold">{formatNumber(timeLeft.seconds)}</span>
				<span className="text-white text-[10px] font-medium">s</span>
			</div>
		</div>
	);
}